import { render, staticRenderFns } from "./governance.vue?vue&type=template&id=5b660cf3&scoped=true"
import script from "./governance.vue?vue&type=script&lang=js"
export * from "./governance.vue?vue&type=script&lang=js"
import style0 from "./governance.vue?vue&type=style&index=0&id=5b660cf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b660cf3",
  null
  
)

export default component.exports